import { Button } from "@omni/ui/components/Button/button.component";
import classnames from "classnames";

import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { scrollToTop } from "@/utils/scroll";

import "./backToTop.scss";

type BackToTopComponentProps = {
    visible: boolean;
    bottomControlsVisible: boolean;
};

const BackToTopComponent = ({
    visible,
    bottomControlsVisible
}: BackToTopComponentProps) => {
    const { t } = useGranite();

    return (
        <Button
            className={classnames(
                "backToTop",
                visible ? "backToTop--visible" : "backToTop--hidden",
                bottomControlsVisible && "backToTop--bottomControlsVisible"
            )}
            type={"button"}
            color={"gray"}
            onClick={() => scrollToTop()}
            aria-label={t("accessibility.backToTopButton.label")}
        >
            <i className="las la-angle-up"></i>
        </Button>
    );
};

export { BackToTopComponent };
